import React from 'react';
import {Button, Grid, Header, Icon, Input, Modal, Label} from 'semantic-ui-react';
import _ from "lodash";
import {socket} from "../../../lib/socketio";
import {isAuthorized} from "../../../lib/authorization";
import { useSelector } from 'react-redux';
import {createUserLog} from "../../../lib/api";
// update FR1.6 Write load/rated time on parameter reset page

const convertValue =(value, name) => {
    if(typeof value === 'undefined'){
        return '';
    }

    if(name === 'IORack5Status' || name === 'IORack6Status' || name === 'LOI Shutdown' ||
        name === 'LOR Enable' || name === 'Cust Norm SD' )
    {
        if(value === 1){
            return 'SD';
        }
        else{
            return 'OK'
        }
    }
    else if(name === 'GFD_Bender'){
        if(value === 1){
            return 'FAULT'
        }
        else{
            return 'OK'
        }
    }
    else if(name === 'CV451' || name ==='CV560' || name === 'CV012' || name ==='CV014' || name==='CV105' || name==='CV140' ||  name==='CV380'
        || name === 'CV511' || name ==='CV150' || name ==='CV510' || name === 'CV720' || name === 'ZS014' ){

        if(name === 'CV014' || name === 'CV720' || name === 'ZS014' || name === 'CV560'){
            if(value===0){
                return 'OPEN';
            }
            else return 'CLOSED';
        }
        else {
            if(value === 1){
                return 'OPEN'
            }
            else{
                return 'CLOSED'
            }
        }

    }
    else{
        if(value === 1){
            return 'ON'
        }
        else{
            return 'OFF'
        }
    }
}

const TimeColumn = ({ index, column, option, data, title, ovrdata, parentCallback, tags, settags, tempovrdata, settempovrdata, tempoverridden, settempoverriden, isCopied, setIsCopied, dataCopy, setDataCopy}) => {

    const [tagdata, settagdata]= React.useState('');
    const [checkdata, setcheckdata]= React.useState('');
    const [open,setOpen]= React.useState(false);
    const [overrideVisible, setOverrideVisible] = React.useState({'visible': true});
    // const [dataCopy, setDataCopy] = React.useState();
    // const [test, setTest] = React.useState();
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);

    const CheckOnOp =(name) => {
        if(name === 'IORack5Status' || name === 'IORack6Status' || name === 'LOI Shutdown' ||
            name === 'LOR Enable' || name === 'Cust Norm SD' )
        {
            return 'SD';
        }
        else if(name === 'GFD_Bender'){
            return 'FAULT';
        }
        else if(name === 'CV451' || name ==='CV560' || name === 'CV012' || name ==='CV014' || name==='CV105' || name==='CV140' ||  name==='CV380'
            || name === 'CV511' || name ==='CV150' || name ==='CV510' || name === 'CV720' || name === 'ZS014' ){
            return 'OPEN';
        }
        else{
            return 'ON';
        }
    }

    const CheckOffOp =(name) => {
        if(name === 'IORack5Status' || name === 'IORack6Status' || name === 'LOI Shutdown' ||
            name === 'LOR Enable' || name === 'Cust Norm SD' || name === 'GFD_Bender' )
        {
            return 'OK';
        }
        else if(name === 'CV451' || name ==='CV560' || name === 'CV012' || name ==='CV014' || name==='CV105' || name==='CV140' ||  name==='CV380'
            || name === 'CV511' || name ==='CV150' || name ==='CV510' || name === 'CV720' || name === 'ZS014'){
            return 'CLOSED';
        }
        else{
            return 'OFF';
        }
    }

    React.useEffect(() => {
        let interval = setInterval(setOverrideVisiblity, 400);
        return() => clearInterval(interval);
    }, [overrideVisible]); // eslint-disable-line react-hooks/exhaustive-deps

    const setOverrideVisiblity = () => {
        setOverrideVisible({...overrideVisible, 'visible': !overrideVisible.visible});
    }

    const handleOpen = (id) => {
        setOpen({...open, [id]:true});
    };

    const handleClose = (id) => {
        settagdata('');
        if(typeof dataCopy !== 'undefined' && (id in dataCopy)){
            delete dataCopy[id];
        }
        setcheckdata('');
        setOpen({...open, [id]:false});
    };

    const handleToggle = (event, id) => {
        event.preventDefault();
        var datavalue;

        if(typeof tagdata === 'undefined' || tagdata === ''){
            datavalue = data[id];
        }
        else datavalue = tagdata;

        var writedata = {'tag_id':id, 'tag_value': datavalue, 'isOverriden': 1};
        var index = ovrdata.findIndex(x => x.tag_id === id);

        if(typeof ovrdata[index] === 'undefined') {
            ovrdata.push(writedata);
        }
        else {
            ovrdata[index] = {'tag_id':id, 'tag_value': datavalue, 'isOverriden': 1};
        }

        settempoverriden({...tempoverridden, [id]: 1});
        settempovrdata({...tempovrdata, [id]: datavalue});
        setOpen({...open, [id]:false});
        settagdata('');
    }

    // [UPDATE] TEST Wirte time parameter reset
    const handleWriteTime = (event, id, name, subgroup) => {
        event.preventDefault();
        var datavalue;
        var btnEventName;

        if(typeof tagdata === 'undefined' || tagdata === ''){
            datavalue = data[id];
        }else{
            datavalue = tagdata;
        }

        var writetime = [{'tag_id' : id, 'tag_value' : datavalue }];


        if(subgroup && subgroup === 'TIME'){
            btnEventName = "Write " + name.substring(0, name.lastIndexOf("_VALUE"));
        }else{
            btnEventName = "Write " + name;
        }

        console.log(btnEventName);
        var writeTimeData = {'buttonClickType': btnEventName, 'tags' : writetime };
        socket.emit('button click', writeTimeData);

        if (!electronApp) {
            let log = {
                user_id: user.id,
                powerplant_id: ppid,
                display_id: null,
                datetime: new Date().toISOString(),
                data: JSON.stringify({ tags: writeTimeData, type: btnEventName }),
            };
            createUserLog({ log }).catch(console.error);
        }

        setOpen({...open, [id]: false});
    }

    const handleDigToggle = (event, id) => {
        event.preventDefault();
        var boolvalue;
        if (typeof checkdata === 'undefine1d' || checkdata === '') {
            boolvalue = data[id];
        } else {
            boolvalue = checkdata;
        }
        if (id === 97792 || id === 97800) { // * CV711, CV713
            var writedata1 = {'tag_id': 97792, 'tag_value': boolvalue, 'isOverriden': 1};
            var writedata2 = {'tag_id': 97800, 'tag_value': boolvalue, 'isOverriden': 1};
            var index1 = ovrdata.findIndex(x => x.tag_id === 97792);
            var index2 = ovrdata.findIndex(x => x.tag_id === 97800);
            if(typeof ovrdata[index1] === 'undefined' && typeof ovrdata[index2] === 'undefined') {
                ovrdata.push(writedata1, writedata2);
            }
            else {
                ovrdata[index1] = {'tag_id': 97792, 'tag_value': boolvalue, 'isOverriden': 1} ;
                ovrdata[index2] = {'tag_id': 97800, 'tag_value': boolvalue, 'isOverriden': 1} ;
            }
            settempoverriden({...tempoverridden, 97792: 1, 97800: 1});
            settempovrdata({...tempovrdata, 97792: boolvalue, 97800: boolvalue});
        } else {
            var writedata = {'tag_id': id, 'tag_value': boolvalue, 'isOverriden': 1};
            var index = ovrdata.findIndex(x => x.tag_id === id);
            if(typeof ovrdata[index] === 'undefined') {
                ovrdata.push(writedata);
            }
            else {
                ovrdata[index] = {'tag_id': id, 'tag_value': boolvalue, 'isOverriden': 1} ;
            }
            settempoverriden({...tempoverridden, [id]: 1});
            settempovrdata({...tempovrdata, [id]: boolvalue});
        }
        setOpen({...open, [id]: false});
        setcheckdata('');
    }

    const handleDigClear =(event, id) => {
        event.preventDefault();
        if(id === 97792 || id === 97800){
            let adiodata = {'buttonClickType': 'Clear Individual Digital Overrides', 'tags': [97792,97800]}
            socket.emit('button click', adiodata);
            delete tempovrdata[97792];
            delete tempovrdata[97800];
            delete tempoverridden[97792];
            delete tempoverridden[97800];
            if(typeof dataCopy !== 'undefined' && (97792 in dataCopy || 97800 in dataCopy)){
                delete dataCopy[97792];
                delete dataCopy[97800];
            }

            setOpen({...open, [id]:false});
            settags([...tags]);
            var index1 = ovrdata.findIndex(x => x.tag_id === 97792);
            var index2 = ovrdata.findIndex(x => x.tag_id === 97800);
            var idsToRemove = [index1, index2];
            for (let j = idsToRemove.length -1; j >= 0; j--){
                ovrdata.splice(idsToRemove[j],1);
            }
            var col_idx1 = column[0].findIndex(x => x.id === 97792);
            var col_idx2 = column[0].findIndex(x => x.id === 97800);
            column[0][col_idx1].isOverriden = 0;
            column[0][col_idx2].isOverriden = 0;
            // setIsCopied(false);
        }else{
            let adiodata = {'buttonClickType': 'Clear Individual Digital Overrides', 'tags': [id]};
            socket.emit('button click', adiodata);
            delete tempovrdata[id];
            delete tempoverridden[id];
            if(typeof dataCopy !== 'undefined' && id in dataCopy){
                delete dataCopy[id];
            }

            setOpen({...open, [id]:false});
            settags([...tags]);
            var index = ovrdata.findIndex(x => x.tag_id === id);
            if (index >= 0) {
                ovrdata.splice( index, 1 );
            }
            var col_idx = column[0].findIndex(x => x.id === id);
            column[0][col_idx].isOverriden = 0;
            // setIsCopied(false);
        }
    }

    const handleChange = (e, {value}) => {
        settagdata(e.target.value);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
    }

    // update SOFC
    const handleCheck = (event, obj_key, name) => {
        if( event.target.id === "1") {
            if(obj_key === 50674 || obj_key === 53573 || obj_key === 40674 || obj_key === 43573 || obj_key === 30674 || obj_key === 33573 ||
                obj_key === 20674 || obj_key === 23573 || obj_key === 10674 || obj_key === 13573 || obj_key === 13319 || obj_key === 23319 ||
                obj_key === 33319 || obj_key === 43319 || obj_key === 53319 || obj_key === 2400 ){ // * Normal Open
                setcheckdata(0);
                setDataCopy({...dataCopy, [obj_key]: 0})
            }
            else{
                setcheckdata(1);
                setDataCopy({...dataCopy, [obj_key]: 1})
            }
            // setDataCopy({...dataCopy, [obj_key]: 1});
        }
        else if( event.target.id === "0"){
            if(obj_key === 50674 || obj_key === 53573 || obj_key === 40674 || obj_key === 43573 || obj_key === 30674 || obj_key === 33573 ||
                obj_key === 20674 || obj_key === 23573 || obj_key === 10674 || obj_key === 13573 || obj_key === 13319 || obj_key === 23319
                || obj_key === 33319 || obj_key === 43319 || obj_key === 53319 || obj_key === 2400){
                setcheckdata(1);
                setDataCopy({...dataCopy, [obj_key]: 1})
            }
            else{
                setcheckdata(0);
                setDataCopy({...dataCopy, [obj_key]: 0})
            }
            // setDataCopy({...dataCopy, [obj_key]: 0});
        }
    }

    const getCheckEnable = (id) => {
        if(typeof dataCopy !== 'undefined' && id in dataCopy){
            if(id === 50674 || id === 53573 || id === 40674 || id === 43573 || id === 30674 || id === 33573 ||
                id === 20674 || id === 23573 || id === 10674 || id === 13573 || id === 13319 || id === 23319 || id === 33319 || id === 43319 || id === 53319 || id === 2400){
                return dataCopy[id] === 0;
            }
            else{
                return dataCopy[id] === 1;
            }
        }
        else {
            if(id === 50674 || id === 53573 || id === 40674 || id === 43573 || id === 30674 || id === 33573 ||
                id === 20674 || id === 23573 || id === 10674 || id === 13573 || id === 13319 || id === 23319 || id === 33319 || id === 43319 || id === 53319 || id === 2400){
                return data[id] === 0;
            }
            else{
                return data[id] === 1;
            }

        }
    }

    const getCheckDisable= (id) => {
        if(typeof dataCopy !== 'undefined' && id in dataCopy){
            if(id === 50674 || id === 53573 || id === 40674 || id === 43573 || id === 30674 || id === 33573 ||
                id === 20674 || id === 23573 || id === 10674 || id === 13573 || id === 13319 || id === 23319 || id === 33319 || id === 43319 || id === 53319 || id === 2400){
                return dataCopy[id] === 1;
            }
            else{
                return dataCopy[id] === 0;
            }
        }
        else {
            if(id === 50674 || id === 53573 || id === 40674 || id === 43573 || id === 30674 || id === 33573 ||
                id === 20674 || id === 23573 || id === 10674 || id === 13573 || id === 13319 || id === 23319 || id === 33319 || id === 43319 || id === 53319 || id === 2400){
                return data[id] === 1;
            }
            else{
                return data[id] === 0;
            }
        }
    }
    const getColor = (parm) => {
        if(option === 2) {
            if(parm === 0) {
                return 'green';
            }
            else {
                return 'red';
            }
        }
        else {
            if (parm === 0) {
                return 'red';
            } else {
                return 'green';
            }
        }
    };

    // update 2403XX, PCS commands Override
    // update 241223, S300TS, add condition : column[i][0].tag_display_subgroup && .includes -> if column[i][0].tag_display_subgroup === null, .includes error occurred
    const gridColumn = _.times((1), (i) => (
        // @ Analog Override
        Object.keys(column).map(i => (
            column[i][0].tag_display_subgroup && (column[i][0].tag_display_subgroup === 'TIME'
                || column[i][0].tag_display_subgroup === 'FUELTOT' || column[i][0].tag_display_subgroup === 'MWHRSNET') ?
                <>
                    {/* <h3 style={{marginTop : '10px', marginBottom : '10px'}}>{column[i][0].tag_display_subgroup}</h3> */}
                    <Grid columns={column[i] && column[i].length >= 10 ? 10 : column[i].length} celled = 'internally' stackable padded style={styles.grid}>
                        {column[i].map(r => // 표기 하지 않을 태그
                            r.tag_display_name === 'CRTAGS' || r.tag_display_name.includes('CRSWORD') || r.tag_display_name.includes('COMMFAULT') ?
                                ''
                                :
                                <Grid.Column style={styles.gridColumn}>
                                    <Grid.Column style={styles.paddingTop}>
                                        { r.tag_display_name === 'HOTTIME'? // disabled button
                                            <Button
                                                key='button'
                                                type='button'
                                                color='teal'
                                                compact
                                                disabled
                                                content={r.tag_display_name}/>
                                            :
                                            <Button
                                                key='button'
                                                type='button'
                                                color='teal'
                                                compact
                                                disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                                content={r.tag_display_name}
                                                onClick={() => {
                                                    setOpen({...open, [r.id]: true}) // example {100: false, 490: false, 596: false, 746: false, 767: false}
                                                }}/>
                                        }
                                        <Modal
                                            key = {r.id}
                                            style = {styles.width}
                                            open = {open[r.id]}
                                            onClose={handleClose[r.id]}
                                            onOpen = {handleOpen[r.id]}>
                                            <Modal.Header>{title}</Modal.Header>
                                            <Modal.Description>
                                                <Header style={styles.header}> Enter Value for {r.tag_display_name} </Header>
                                            </Modal.Description>
                                            <Modal.Content>
                                                <form autoComplete='off' onSubmit={handleSubmit}>
                                                    <Input focus autoFocus placeholder='Value' style={styles.input}
                                                           name='Input change'
                                                           label = {r.unit || ""}
                                                           labelPosition='right'
                                                           type='number'
                                                           step ='0.00001'
                                                           size='small'
                                                           min ={r.min}
                                                           max ={r.max}
                                                           onChange={(event, value) => handleChange(event, value)}
                                                           defaultValue = {data[r.id]}
                                                    />
                                                </form>
                                            </Modal.Content>
                                            <Modal.Actions>
                                                <Button color='blue' content={'Ok'} onClick={(event, value) => handleWriteTime(event, r.id, r.name, r.tag_display_subgroup)}/>
                                                <Button color='red' content={'Cancel'} onClick={  () => handleClose(r.id)}/>
                                            </Modal.Actions>
                                        </Modal>
                                    </Grid.Column>
                                    {/* 소수점 표기  */}
                                    <Grid.Column style ={{fontSize: '18px'}}> {typeof data[r.id] !== 'undefined' ? ((r.id === 99999) ? data[r.id].toFixed(3) : data[r.id].toFixed(1)) : ''}
                                        <span style={{color: '#04BFBF', marginLeft: '5px'}}>{r.unit} </span>
                                    </Grid.Column>
                                    <Grid.Column style={{color: '#f5c71a',paddingBottom: '0'}}> {tempovrdata[r.id]}
                                        {(typeof tempoverridden !== 'undefined' && typeof tempoverridden[r.id] !== 'undefined' && tempoverridden[r.id] === 1 && overrideVisible.visible && r.isOverriden !== 1) ||
                                        (r.isOverriden === 1 && overrideVisible.visible)?
                                            <Icon style={styles.overriden} name='asterisk' color='yellow' size='small' />
                                            : <Icon style={styles.overriden} name='asterisk' color='black' size='small' />
                                        }
                                    </Grid.Column>
                                </Grid.Column>
                        )}
                    </Grid>
                </>
                : // @ Digital Override - PCS Commands
                column[i][0].page_name && column[i][0].page_name.includes('Digital I/O Override') || column[i][0].tag_display_subgroup === 'PCS COMMANDS OVERRIDES' ?
                    <>
                        <h3 style={{marginTop : '10px', marginBottom : '10px'}}>{column[i][0].tag_display_subgroup}</h3>
                        <Grid columns={column[i] && column[i].length < 10 ? column[i].length : 10} celled = 'internally' stackable padded style={styles.grid}>
                            {column[i].map(r =>
                                r.tag_display_name === 'FAN151OBS' || r.tag_display_name && r.tag_display_name.includes('CRSWORD') || r.tag_display_name && r.tag_display_name.includes('COMMFAULT')|| (option ===2 && r.tag_display_name === 'PMP400') || r.tag_display_subgroup === 'PPC TO PCS GENERAL CONTROL WORD'?
                                    '' :
                                    <Grid.Column style={styles.gridColumn}>
                                        <Grid.Column  style ={{paddingTop: '0px', marginLeft : '10px', marginRight : '10px'}}>
                                            { r.tag_display_name === 'PS600' || r.tag_display_name === 'FS160' || (r.display_id === 76 && (r.tag_display_name === 'BAT001' || r.tag_display_name === 'PS001' || r.tag_display_name === 'UPS001'))
                                            || (r.display_id === 201 && (r.tag_display_name === 'BAT002' || r.tag_display_name === 'PS002' || r.tag_display_name === 'UPS002')) || (r.display_id === 202 && (r.tag_display_name === 'BAT003' || r.tag_display_name === 'PS003' || r.tag_display_name === 'UPS003'))
                                            || (r.display_id === 203 && (r.tag_display_name === 'BAT004' || r.tag_display_name === 'PS004' || r.tag_display_name === 'UPS004')) || (r.display_id === 204 && (r.tag_display_name === 'BAT005' || r.tag_display_name === 'PS005' || r.tag_display_name === 'UPS005'))? //PS600 and FS160
                                                <Button
                                                    key='button'
                                                    type='button'
                                                    compact
                                                    disabled
                                                    content={r.tag_display_name}
                                                />
                                                :
                                                option === 2 && r.tag_display_name === 'VSD400' ?
                                                    <>
                                                        <Button
                                                            key='button'
                                                            type='button'
                                                            color='teal'
                                                            compact
                                                            style={styles.textwrap}
                                                            disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                                            content='PMP400'
                                                            onClick={() => {
                                                                setOpen({...open, [r.id]: true})
                                                            }}/>
                                                        <Modal
                                                            key = {r.id}
                                                            style = {styles.width}
                                                            open = {open[r.id]}
                                                            onClose={handleClose[r.id]}
                                                            onOpen={handleOpen[r.id]}>
                                                            <Modal.Header>{title} </Modal.Header>
                                                            <Modal.Description>
                                                                <Header style={styles.header}>Enter Value for PMP400 </Header>
                                                            </Modal.Description>
                                                            <Modal.Content>
                                                                <Button.Group toggle>
                                                                    <Button
                                                                        size='medium'
                                                                        id={1}
                                                                        active={getCheckEnable(r.id)}
                                                                        onClick={(event, value) => handleCheck(event, r.id)}
                                                                        content={CheckOnOp(r.tag_display_name)}
                                                                    />
                                                                    <Button
                                                                        size='medium'
                                                                        id={0}
                                                                        active={getCheckDisable(r.id)}
                                                                        onClick={(event, value) => handleCheck(event, r.id)}
                                                                        content={CheckOffOp(r.tag_display_name)}
                                                                    />
                                                                </Button.Group>
                                                                <Button style = {styles.clrOvrBtn} color='blue' content={'Clear Overrides'} onClick={(event, value) => handleDigClear(event, r.id)}/>
                                                            </Modal.Content>
                                                            <Modal.Actions style = {styles.toggle}>
                                                                <Button color='blue' content={'Ok'} onClick={(event, value) => handleDigToggle(event, r.id)}/>
                                                                <Button color='red' content={'Cancel'} onClick={() => handleClose(r.id)}/>
                                                            </Modal.Actions>
                                                        </Modal>
                                                    </>
                                                    :
                                                    <> {/** PCS Commands 버튼 처리  */}
                                                        <Button
                                                            key='button'
                                                            type='button'
                                                            color='teal'
                                                            compact
                                                            disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                                            // style={styles.textwrap}
                                                            content={r.tag_display_name}
                                                            onClick={() => {
                                                                setOpen({...open, [r.id]: true})
                                                            }}/>
                                                        <Modal
                                                            key = {r.id}
                                                            style = {styles.width}
                                                            open = {open[r.id]}
                                                            onClose={handleClose[r.id]}
                                                            onOpen={handleOpen[r.id]}>
                                                            <Modal.Header>{title} </Modal.Header>
                                                            <Modal.Description>
                                                                <Header style={styles.header}>
                                                                    Enter Value for {r.tag_display_name} </Header>
                                                            </Modal.Description>
                                                            <Modal.Content>
                                                                <Button.Group toggle>
                                                                    <Button
                                                                        size='medium'
                                                                        id={1}
                                                                        active={getCheckEnable(r.id)}
                                                                        onClick={(event, value) => handleCheck(event, r.id)}
                                                                        content={CheckOnOp(r.tag_display_name)}
                                                                    />
                                                                    <Button
                                                                        size='medium'
                                                                        id={0}
                                                                        active={getCheckDisable(r.id)}
                                                                        onClick={(event, value) => handleCheck(event, r.id)}
                                                                        content={CheckOffOp(r.tag_display_name)}
                                                                    />
                                                                </Button.Group>
                                                                <Button style = {styles.clrOvrBtn} color='blue' content={'Clear Overrides'} onClick={(event, value) => handleDigClear(event, r.id)}/>
                                                            </Modal.Content>
                                                            <Modal.Actions style = {styles.toggle}>
                                                                <Button color='blue' content={'Ok'} onClick={(event, value) => handleDigToggle(event, r.id)}/>
                                                                <Button color='red' content={'Cancel'} onClick={() => handleClose(r.id)}/>
                                                            </Modal.Actions>
                                                        </Modal>
                                                    </>
                                            }
                                        </Grid.Column>
                                        {(convertValue(data[r.id], r.tag_display_name) === 'ON' || (convertValue(data[r.id], r.tag_display_name) === 'OPEN' && (r.tag_display_name !== 'CV014' && r.tag_display_name !== 'CV720' && r.tag_display_name !== 'ZS014' && r.tag_display_name !== 'CV560')) ||  ((r.tag_display_name === 'CV014' || r.tag_display_name === 'CV720' || r.tag_display_name === 'ZS014' || r.tag_display_name === 'CV560') && convertValue(data[r.id], r.tag_display_name) === 'CLOSED' )) ?
                                            (<Grid.Column style ={{fontSize: '18px', color: 'green', fontWeight: 'bold', textAlign : 'center'}}> {convertValue(data[r.id], r.tag_display_name)} </Grid.Column>)
                                            : (<Grid.Column style ={{fontSize: '18px', textAlign : 'center'}}> {convertValue(data[r.id], r.tag_display_name)}
                                            </Grid.Column>)
                                        }
                                        <Grid.Column style={{color: '#f5c71a',paddingBottom: '0', textAlign : 'center'}}> {convertValue(tempovrdata[r.id], r.tag_display_name)}
                                            {(typeof tempoverridden !== 'undefined' && typeof tempoverridden[r.id] !== 'undefined' && tempoverridden[r.id] === 1 && overrideVisible.visible && r.isOverriden !== 1) ||
                                            (r.isOverriden === 1 && overrideVisible.visible)?
                                                <Icon style={styles.overriden} name='asterisk' color='yellow' size='small' />
                                                : <Icon style={styles.overriden} name='asterisk' color='black' size='small' />}
                                        </Grid.Column>
                                    </Grid.Column>
                            )}
                        </Grid>
                    </>
                    : ''

        ))
    ))
    return (
        <div>
            <Grid.Row key={index} style={{ maxWidth: '1800px', padding: '2px 0',margin:'0'}}>
                {gridColumn}
            </Grid.Row>
        </div>
    );
};

const styles = {
    grid: {
        margin: '0',
        paddingBottom: '0'
    },
    girdPCSCommands : {
        mairginTop : '10px'
    },
    row: {
        padding: '2px 0'
    },
    name: {
        color: 'yellow'
    },
    input: {
        width: '150px'
    },
    width: {
        maxWidth: '300px'
    },
    header: {
        marginTop: '20px',
        marginLeft: '10px'
    },
    toggle: {
        marginLeft: '8px'
    },
    checkbox: {
        flexDirection: 'row-reverse',
        marginLeft: '10px'
    },
    overriden: {
        marginLeft: '15px'
    },
    textwrap: {
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
        width : '150px'
    },
    gridColumn: {
        paddingTop: '0px',
        paddingBottom: '7px'
    },
    paddingTop: {
        paddingTop: '0px'
    },
    clrOvrBtn: {
        marginTop: '10px'
    },

};

export default React.memo(TimeColumn);
